import { useRef, useState, useEffect } from "react";
import styles from "./index.css";
import BannerContent from "./BannerContent";
import PropTypes from "prop-types";
import shouldEnableBanner from "./shouldEnableBanner";

const LoyaltyEarlyAccessSaleBanner = ({
  categoryId,
  isEarlyAccessSaleAvailable,
  isEarlyAccessSaleEventActive,
  storeCode
}) => {
  const bannerRef = useRef(null);

  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    setIsEnabled(
      shouldEnableBanner({
        categoryId,
        isEarlyAccessSaleAvailable,
        isEarlyAccessSaleEventActive,
        storeCode
      })
    );
  }, [isEarlyAccessSaleAvailable, isEarlyAccessSaleEventActive, storeCode]);

  if (!isEnabled) {
    return null;
  }

  return (
    <li className={styles.loyaltyEarlyAccessSaleBanner} ref={bannerRef}>
      <BannerContent />
    </li>
  );
};

LoyaltyEarlyAccessSaleBanner.propTypes = {
  categoryId: PropTypes.string.isRequired,
  isEarlyAccessSaleAvailable: PropTypes.boolean,
  isEarlyAccessSaleEventActive: PropTypes.boolean,
  storeCode: PropTypes.string
};

export default LoyaltyEarlyAccessSaleBanner;
